import { KonvaEventObject } from "konva/lib/Node";
import { CircleConfig } from "konva/lib/shapes/Circle";
import { LineConfig } from "konva/lib/shapes/Line";
import React, { useCallback } from "react";
import { Circle, Line } from "react-konva";
import { IPoint } from "types";

interface IPolygon {
  points: IPoint[];
  maxX: number;
  maxY: number;
  isSelected?: boolean;
  onChange?: (points: IPoint[]) => void;
  lineProps?: LineConfig;
  circleProps?: CircleConfig;
}

const Polygon = ({ points, maxX, maxY, isSelected, onChange, lineProps, circleProps }: IPolygon) => {
  const handlePointDragMove = useCallback(
    (index: number, event: KonvaEventObject<DragEvent>) => {
      let { x, y } = event.target.position();
      if (x < 0) x = 0;
      if (y < 0) y = 0;
      if (x > maxX) x = maxX;
      if (y > maxY) y = maxY;
      event.target.position({ x, y });
      onChange && onChange([...points.slice(0, index), { x, y }, ...points.slice(index + 1)]);
    },
    [maxX, maxY, onChange, points]
  );

  return (
    <React.Fragment>
      <Line
        stroke="black"
        fill="rgba(0,0,0,0.3)"
        closed
        // draggable
        // onDragMove={onDragMove}
        points={points.flatMap((p) => [p.x, p.y])}
        {...lineProps}
      />
      {points.map((point, index) => (
        <Circle
          key={index}
          x={point.x}
          y={point.y}
          radius={5}
          fill={isSelected ? "pink" : "lightblue"}
          stroke={isSelected ? "red" : "blue"}
          strokeWidth={2}
          draggable
          onDragMove={(event) => handlePointDragMove(index, event)}
          {...circleProps}
        />
      ))}
    </React.Fragment>
  );
};

export default Polygon;
